import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc1011',
    ecrans: ['00-2'],
    params: ['id', '?refcleint']

});

